export const AUDIENCE_ID_PARAM_NAME = 'audienceId';
export const AUDIENCE_ID_PARAM_TEMPLATE = `/:${AUDIENCE_ID_PARAM_NAME}?`;
